export interface TitleType {
  url: string | false;
  title: string;
  breadcrumbs: boolean;
  type: string;
  link?: string;
  key?: number;
}

export interface Alert {
  id: string;
  type: 'info' | 'warning' | 'error' | 'success';
  message: string;
  url: string;
  linkText: string;
  cssClass?: string;
}

